import clsx from "clsx";

const AdminCard = ({
  title,
  subtitle,
  actions = null,
  children,
  className = "",
  bodyClassName = "",
}) => {
  return (
    <section className={clsx("content-card-lg p-6", className)}>
      {(title || subtitle || actions) && (
        <div className="mb-5 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
          <div>
            {title ? (
              <h2 className="text-xl font-semibold text-henna">{title}</h2>
            ) : null}

            {subtitle ? (
              <p className="mt-2 text-sm leading-6 text-muted-warm">
                {subtitle}
              </p>
            ) : null}
          </div>

          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
      )}

      <div className={bodyClassName}>{children}</div>
    </section>
  );
};

export default AdminCard;